<template>
  <div class="batch-card-show-details">
    <div
      v-if="!isDetailsMode"
      :id="'batch-card-show-' + index"
      class="batch-card-show-details__icon"
    >
      <router-link
        :to="{
          path: `/print-tag/batches/${id}`,
          query: {
            orderPrintBy: orderBy
          }
        }"
        :id="'batch-card-show-details-icon-' + index"
        class="icon-container show"
        @click="handleTrackBatchDetails"
      >
        <svg-loader src="/static/images/icon-show-details.svg" />

        <md-tooltip
          md-delay="100"
          md-direction="top"
        >
          Mostrar amostras
        </md-tooltip>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BatchCardShowDetails',
  props: {
    orderBy: {
      type: String
    },
    isDetailsMode: {
      type: Boolean
    },
    id: {
      type: [String, Number]
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters([
      'batchesCurrentTab',
      'profile'
    ])
  },
  methods: {
    handleTrackBatchDetails() {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Impressão de Etiquetas - Lote',
        'action': 'Visualizar detalhes do lote',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@/../static/stylesheets/variables" as *;

.batch-card-show-details {
  &__icon {
    display: flex;
    height: 30px;

    .hide {
      .md-icon {
        width: 30px;
        height: 28px;
        padding: 5px 5px 5px 0;
        margin-top: 0.1em;
        > svg {
          path {
            fill: $theme-primary-color;
            transition: 0.5s;
          }
        }
      }
    }

    .show {
      .md-icon {
        width: 20px;
        height: 20px;
        min-width: 23px;
        margin-top: 0.1em;
      }
    }

    .icon-container {
      cursor: pointer;
      height: 45px;

      &:hover,
      &:focus {
        .md-icon > svg {
          path {
            fill: $theme-primary-color;
            transition: 0.5s;
          }
        }
      }
    }
  }
}
</style>
